import React from 'react';
import PropTypes from 'prop-types';
import { PageHeader } from './styles';
import { localization } from './localizations';
import { BdsTypo } from 'blip-ds/dist/blip-ds-react';
import { DateDropdown } from '../../../../../components/DateDropdown';
import { useContentLocalizer } from '../../../../../hooks/useContentLocalizer';
import { DataProtectionAlert } from '../DataProtectionAlertHeader/DataProtectionAlert';

const PageHeaderComponent = ({ title, dateToSearch, periodOptions, periodOptionChangeEvent }) => {
  const content = useContentLocalizer(localization);
  return (
    <>
      <DataProtectionAlert />
      <PageHeader>
        <BdsTypo variant="fs-40" bold="bold" lineHeight="plus">
          {title}
        </BdsTypo>
        <DateDropdown
          value={dateToSearch.toISOString()}
          options={periodOptions}
          bdsChangeEvent={periodOptionChangeEvent}
          label={content.monthPlaceholder}
        ></DateDropdown>
      </PageHeader>
    </>
  );
};

PageHeaderComponent.propTypes = {
  title: PropTypes.string.isRequired,
  dateToSearch: PropTypes.any.isRequired,
  periodOptions: PropTypes.array.isRequired,
  periodOptionChangeEvent: PropTypes.func.isRequired,
};

export { PageHeaderComponent };
